<template>
  <div>
    <p :class="titleDef"> {{title}} </p>
      <input :class="classDef" v-model="myValue" :placeholder="placeholder" v-on:change="onChange" :disabled="disabled" 
          :maxLength="maxLength" :type="valueType"
          oninput="this.value = this.value.slice(0, this.maxLength)"/>
    <p class="error" v-if="errorMode !== ''" style="font-size: 13px; border: none; color: rgb(218, 97, 97);">{{ errorMode }}</p>
  </div>
</template>

<script>
export default { 
  props: {
    value: {
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: null,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    inputClass: {
      type: String,
      required: false
    },
    titleClass: {
      type: String,
      default: '',
      required: false
    },
    maxLength: {
      type: Number,
      required: false,
      default: 100
    },
    valueType: {
      type: String,
      required: false
    },
    errorMode: {
      type: String,
      default: ''
    },
    onlyNumbersWithNegatives: {
      type: Boolean,
      default: false
    }
  },
  watch: { 
    value: function(newVal, oldVal) {
      this.myValue = newVal;
    }
  },
  data() {
    return {
      myValue: this.value
    };
  },
  computed: {
    classDef() {
      return this.errorMode === '' ? `input pl-2  ${this.inputClass}` : `input pl-2 error ${this.inputClass}`;
    },
    titleDef() {
      return this.titleClass === '' ? `title mt-3` : `${this.titleClass} mt-3`;
    }
  },
  methods: {
    onChange: function(evt) {
      this.$emit("onChange", evt.target.value);
    }
  }
}
</script>

<style>
input:disabled {
  background: #f1f1f1;
}

</style>

<style scoped>
.input {
  border-radius: 5px;
  color: black;
}

input::placeholder {
  color: rgb(0, 149, 178);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>


// WEBPACK FOOTER //
// src/components/TextField.vue